import React from "react";
import { Link } from "react-router-dom";
import { Phone, Camera, Zap } from "lucide-react";
import { company } from "../data/mock";

// Mobile-only sticky action bar: Call · Text Chris · Instant Quote.
const StickyContactBar = () => (
  <>
    <div className="h-16 lg:hidden" aria-hidden />
    <div className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="sticky-contact-bar">
      <div className="grid grid-cols-3 divide-x divide-slate-100">
        <a href={company.phoneLink} data-testid="sticky-call" className="flex flex-col items-center justify-center py-2.5 text-[#0a1f44] active:bg-slate-50">
          <Phone className="w-5 h-5 text-[#3b9dff]" />
          <span className="text-[11px] font-semibold mt-0.5">Call</span>
        </a>
        <a href={company.photoSms} data-testid="sticky-text" className="flex flex-col items-center justify-center py-2.5 text-[#0a1f44] active:bg-slate-50">
          <Camera className="w-5 h-5 text-[#3b9dff]" />
          <span className="text-[11px] font-semibold mt-0.5">Text a Wall Photo</span>
        </a>
        <Link to="/tv-mounting-quote" data-testid="sticky-quote" className="flex flex-col items-center justify-center py-2.5 bg-[#3b9dff] text-white">
          <Zap className="w-5 h-5" />
          <span className="text-[11px] font-bold mt-0.5">Instant Quote</span>
        </Link>
      </div>
    </div>
  </>
);

export default StickyContactBar;
